var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C6.16462 0 6.32249 0.0653938 6.43889 0.181796C6.5553 0.298198 6.62069 0.456073 6.62069 0.62069V5.37931H11.3793C11.5439 5.37931 11.7018 5.4447 11.8182 5.56111C11.9346 5.67751 12 5.83538 12 6C12 6.16462 11.9346 6.32249 11.8182 6.43889C11.7018 6.5553 11.5439 6.62069 11.3793 6.62069H6.62069V11.3793C6.62069 11.5439 6.5553 11.7018 6.43889 11.8182C6.32249 11.9346 6.16462 12 6 12C5.83538 12 5.67751 11.9346 5.56111 11.8182C5.4447 11.7018 5.37931 11.5439 5.37931 11.3793V6.62069H0.62069C0.456073 6.62069 0.298198 6.5553 0.181796 6.43889C0.0653938 6.32249 0 6.16462 0 6C0 5.83538 0.0653938 5.67751 0.181796 5.56111C0.298198 5.4447 0.456073 5.37931 0.62069 5.37931H5.37931V0.62069C5.37931 0.456073 5.4447 0.298198 5.56111 0.181796C5.67751 0.0653938 5.83538 0 6 0Z",
    fill: "#081B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusBlue);
export default __webpack_public_path__ + "static/media/plusBlue.ba005d56c568c05690487b31b2c37400.svg";
export { ForwardRef as ReactComponent };